export const goTo = {
  methods: {
    goTo(route) {
      const params = this.$route.params;
      let tenant = params.tenant || process.env.VUE_APP_DEFAULT_TENANT;

      if (route && route !== "/") {
        tenant !== process.env.VUE_APP_DEFAULT_TENANT
          ? this.$router.push(`/${tenant}${route}`)
          : this.$router.push(route);
      } else {
        tenant !== process.env.VUE_APP_DEFAULT_TENANT
          ? this.$router.push(`/${tenant}`)
          : this.$router.push("/");
      }
    }
  }
};
